import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { KeywordsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const keywords = graphql(`
  query keywords {
    keywords {
      companyName
      keywords
    }
  }
`);

export function useKeywords(
  options?: UseQueryOptions<KeywordsQuery, unknown, KeywordsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(["keywords"], keywords, [], {
    ...options,
  });
  return { data: data?.keywords, ...rest };
}
